import React from 'react'
import { Modal } from '.'
import { Button } from './legacy'
import { CiCircleQuestion } from 'react-icons/ci'

function ConfirmationBox({
  title, //Tiêu đề
  message, //Lời nhắc
  onConfirm,
  onCancel,
  confirmButtonText = 'Xác nhận',
  cancelButtonText = 'Huỷ',
  className = '',
}) {
  return (
    <Modal
      onClose={onCancel}
      className={`w-fit rounded-lg bg-white p-5 ${className} fixed bottom-8 right-8 text-center`}
    >
      <div className="flex w-full justify-center text-center">
        <CiCircleQuestion size={60} />
      </div>
      <h1 className="my-2 text-lg font-bold">{title}</h1>
      {message && (
        <p className={`mb-4 mt-2 text-gray-700 ${className}`}>{message}</p>
      )}
      <div className="flex w-full flex-col items-center justify-between gap-4">
        <Button
          variant={'primary'}
          onClickHandler={onConfirm}
          rounded="lg"
          className="w-full flex-1 whitespace-nowrap px-4"
        >
          {confirmButtonText}
        </Button>
        <Button
          onClickHandler={onCancel}
          rounded="lg"
          className="flex-1 bg-white font-bold text-black underline"
        >
          {cancelButtonText}
        </Button>
      </div>
    </Modal>
  )
}

export default ConfirmationBox
